import { Component, OnInit, ViewChild, ElementRef, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { Observable } from 'rxjs';
import { User } from '../../../models/shared-component/user';
import { UserRoleMapping } from '../../../models/user-management-model/permission-group';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  user$: Observable<User | null>;
  userRoleMapping$: Observable<UserRoleMapping[] | null>;
  currentRole: UserRoleMapping | null;

  constructor(
    @Inject(DOCUMENT) private document: Document, 
    private renderer: Renderer2,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.user$ = this.authService.currentUserSubject.asObservable();
    this.userRoleMapping$ = this.authService.userRoleMappingSubject.asObservable();

    this.currentRole = this.authService.currentRoleSubject.value;
    console.log(this.currentRole);

  }

  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar(e: Event) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  /**
   * Logout
   */
  onLogout(e: Event) {
    e.preventDefault();
    this.authService.logout();
  }

  onSelectRole(selectedRole: UserRoleMapping) {
    this.authService.onSelectCurrentRole(selectedRole);
  }

}
